module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('data-table', {
    attrs: {
      "table-ref": "utiltable",
      "title": _vm.tableTitle,
      "icon": "fa fa-plug",
      "url": '/utility/site/' + _vm.rowData.id,
      "fields": _vm.fields,
      "hide-top": _vm.hideHeading,
      "show-title": _vm.showTitle,
      "show-search": _vm.showSearch,
      "add-action": _vm.canAccess('finance|admin') ? _vm.action : null,
      "add-props": _vm.canAccess('finance|admin') ? _vm.addPropsData : null,
      "detail-component": "utility-detail-row"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c3bdf5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/utility/SiteUtilTable.vue
// module id = 1467
// module chunks = 0